/**
 * router/routes/dashboard.routes.ts
 * The dashboard landing route (and its '' index redirect) nested under the
 * tenant AppShell. Split out of router/index.ts
 * (openspec/arquitectura/convencion-modulo.md §4).
 */
import type { RouteRecordRaw } from 'vue-router';

export const dashboardRoutes: RouteRecordRaw[] = [
  // FS-8.4: / and catch-all redirect to dashboard (PR-3 flip from service-orders).
  { path: '', redirect: { name: 'dashboard' } },

  {
    path: 'dashboard',
    name: 'dashboard',
    component: () => import('../../views/DashboardView.vue'),
    // add-app-shell-nav-redesign: Inicio has no module active, so the sidebar has
    // nothing contextual to show — hidden entirely (FS-1.4) rather than rendering
    // an empty rail. Admin/Catálogos/etc. live in the topbar now, not here.
    meta: { hideSidebar: true },
  },
];

// FS-8.4: catch-all child — targets dashboard (PR-3 flip from service-orders).
// Kept here (not module-specific) and spread LAST in router/index.ts's tenant
// AppShell children array.
export const dashboardCatchAllRoute: RouteRecordRaw[] = [
  // Catch-all child — FS-8.4: targets dashboard (PR-3 flip from service-orders)
  { path: ':pathMatch(.*)*', redirect: { name: 'dashboard' } },
];
